import { STORAGE_KEYS } from "../constants/defaults";

function canUseLocalStorage() {
  try {
    return typeof window !== "undefined" && !!window.localStorage;
  } catch {
    return false;
  }
}

function readJson(key, fallback) {
  if (!canUseLocalStorage()) return fallback;
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  if (!canUseLocalStorage()) return;
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // noop (quota or privacy mode)
  }
}

function readScalar(key, fallback = null) {
  if (!canUseLocalStorage()) return fallback;
  try {
    const raw = window.localStorage.getItem(key);
    return raw == null ? fallback : raw;
  } catch {
    return fallback;
  }
}

function writeScalar(key, value) {
  if (!canUseLocalStorage()) return;
  try {
    if (value == null) {
      window.localStorage.removeItem(key);
      return;
    }
    window.localStorage.setItem(key, String(value));
  } catch {
    // noop
  }
}

// Mock repository adapter. Future backend integration can keep this interface.
export const scenarioRepositoryMock = {
  loadState() {
    return {
      scenarios: readJson(STORAGE_KEYS.scenarios, null),
      activeScenarioId: readScalar(STORAGE_KEYS.activeScenarioId, null),
      executionHistory: readJson(STORAGE_KEYS.executionHistory, null),
      preferences: readJson(STORAGE_KEYS.preferences, null),
    };
  },

  saveState({ scenarios, activeScenarioId, executionHistory, preferences }) {
    if (Array.isArray(scenarios)) writeJson(STORAGE_KEYS.scenarios, scenarios);
    if (typeof activeScenarioId !== "undefined") {
      writeScalar(STORAGE_KEYS.activeScenarioId, activeScenarioId);
    }
    if (Array.isArray(executionHistory)) {
      writeJson(STORAGE_KEYS.executionHistory, executionHistory.slice(0, 50));
    }
    if (preferences && typeof preferences === "object") {
      writeJson(STORAGE_KEYS.preferences, preferences);
    }
  },
};

export default scenarioRepositoryMock;
